var exports = {
  "az": "Box__v-wiAm",
  "wy": "Box_1__idtrmF",
  "pv": "Box_2__Uo3L_C",
  "sp": "isSelected__2Jz5im",
  "vX": "isRedacted__28JHL3",
  "Y9": "Header__3Ms804",
};

module.exports = exports;
